/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesGamesChooseGameTurnstileOptions interface.
 */
export function instanceOfFxIdWebFeaturesGamesChooseGameTurnstileOptions(value) {
    if (!('SiteKey' in value) || value['SiteKey'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSON(json) {
    return FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SiteKey': json['SiteKey'],
    };
}
export function FxIdWebFeaturesGamesChooseGameTurnstileOptionsToJSON(json) {
    return FxIdWebFeaturesGamesChooseGameTurnstileOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGameTurnstileOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SiteKey': value['SiteKey'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesGamesChooseGameTurnstileOptions.js.map